import { useDispatch, useSelector } from 'react-redux'
import {
  clearError,
  loginThunk,
  logoutThunk,
  restoreSession,
} from '../store/authSlice.js'

export const useAuth = () => {
  const dispatch = useDispatch()
  const auth = useSelector((state) => state.auth)

  return {
    ...auth,
    login: (credentials) => dispatch(loginThunk(credentials)),
    logout: () => dispatch(logoutThunk()),
    restore: () => dispatch(restoreSession()),
    clearError: () => dispatch(clearError()),
  }
}
